import { colors } from 'utils/colors'

type Variant = {
  color: keyof typeof colors
  icon: string[]
  name: string
}

export const variants: Variant[] = [
  {
    color: 'gray7',
    icon: ['far', 'info-circle'],
    name: 'info',
  },
  {
    color: 'green',
    icon: ['far', 'check-circle'],
    name: 'success',
  },
  {
    color: 'red',
    icon: ['far', 'times-circle'],
    name: 'error',
  },
  {
    color: 'yellow',
    icon: ['far', 'exclamation-triangle'],
    name: 'warning',
  },
]
